import React from 'react';
import { connect } from 'react-redux'
import { compose, lifecycle } from 'recompose';
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';
import RaisedButton from 'material-ui/RaisedButton';
import SearchToolbar from './SearchToolbar'
import {findCountryCustomerBranches} from '../../store/actions/branchSearch'
import {fetchGroupsUser} from '../../store/actions/groups';


const BranchSearchForm = (props)=> {

    const {searchResult, filter, onAddButtonClicked, groups} = props;

    const resultlist = filter(searchResult);

    return(
        <div>
            <SearchToolbar groups={groups} onSearchClicked={(key, group, includeCountry)=>{props.findCustomerBranches(key, group, includeCountry)}}/>
            <Table>
                <TableHeader adjustForCheckbox={false} displaySelectAll={false} >
                    <TableRow>
                        <TableHeaderColumn>Country</TableHeaderColumn>
                        <TableHeaderColumn>Customer</TableHeaderColumn>
                        <TableHeaderColumn>Branch</TableHeaderColumn>
                        <TableHeaderColumn></TableHeaderColumn>
                    </TableRow>
                </TableHeader>
                <TableBody showRowHover={true} displayRowCheckbox={false}>
                    {resultlist.map((ccb, index) =>(
                            <TableRow key={index}>
                                <TableRowColumn>{ccb.countryName}</TableRowColumn>
                                <TableRowColumn>{ccb.customerName}</TableRowColumn>
                                <TableRowColumn>{ccb.branchName}</TableRowColumn>
                                <TableRowColumn>
                                    <RaisedButton label="Add" primary={true} onTouchTap={()=>{onAddButtonClicked(ccb)}}/>
                                </TableRowColumn>
                            </TableRow>
                        )
                    )}
                </TableBody>
            </Table>
        </div>
    )
};

const mapStateToProps = (state) => {
    return {
        groups: state.groups.groupsuser,
        searchResult: state.branchSearch.searchResult || []
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        findCustomerBranches: (text, group, includeCountry)=>{
            dispatch(findCountryCustomerBranches(text, group, includeCountry))
        },
        fetchGroupsUser: () => {
            dispatch(fetchGroupsUser())
        }
    }
};

const lifecycleValue = {
    componentWillMount() {
        this.props.fetchGroupsUser();
    }
};

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    lifecycle(lifecycleValue),
)(BranchSearchForm);





// WEBPACK FOOTER //
// ./src/components/branchSelector/BranchSearchForm.js